import { render, staticRenderFns } from "./CoverCard.vue?vue&type=template&id=6da2e88c&scoped=true&"
import script from "./CoverCard.vue?vue&type=script&lang=js&"
export * from "./CoverCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2e88c",
  null
  
)

export default component.exports